import * as React from 'react';
import { Typography } from '@mui/material';
import { useCollectionBillingCtx } from '@europrocurement/l2d-modules/providers/CollectionBillingProvider';

type OrderDetailsTotalAmountProps = {
    totalAmount: string;
    totalRemainingAmount?: string;
};

const OrderDetailsTotalAmount: React.FunctionComponent<OrderDetailsTotalAmountProps> = function ({
    totalAmount,
    totalRemainingAmount,
}) {
    const { isFetchingBillingDossierIds, isFetchingDataPrefacturation } = useCollectionBillingCtx();

    const fetchingData = isFetchingBillingDossierIds() || isFetchingDataPrefacturation();

    return (
        <>
            <Typography
                variant="l2dlabel"
                sx={{ color: 'text.gris70' }}
            >
                Total TTC :
            </Typography>
            <Typography
                variant="l2dh7"
                sx={{
                    color: 'text.primary',
                    fontWeight: '600',
                }}
            >
                {fetchingData ? '-' : ` ${totalAmount} €`}
            </Typography>
            {totalRemainingAmount !== undefined && Number(totalRemainingAmount) > 0 ? (
                <>
                    <Typography
                        variant="l2dlabel"
                        sx={{ color: 'text.gris70' }}
                    >
                        Reste à facturer :
                    </Typography>
                    <Typography
                        variant="l2dh7"
                        sx={{
                            color: 'text.primary',
                            fontWeight: '600',
                        }}
                    >
                        {fetchingData ? '-' : ` ${totalRemainingAmount} €`}
                    </Typography>
                </>
            ) : null}
        </>
    );
};

export default OrderDetailsTotalAmount;
